import React from 'react';
import { LuCircleCheck, LuExternalLink } from 'react-icons/lu';

import { ChatMessageAction } from '../../entities/chat-message-action';
import { useConnectedIntegrations } from '../../shared/hooks/use-connected-integrations';

const PROVIDER_LABEL: Record<ChatMessageAction['provider'], string> = {
  jira: 'Jira',
  trello: 'Trello',
  slack: 'Slack',
  telegram: 'Telegram',
};

interface ChatMessageActionsProps {
  actions: ChatMessageAction[];
}

// Renders the button(s) a `connect_integration` action carries (integration-agent-contract.md §3)
// below an agent's chat bubble — the FE-owned CTA in place of a raw URL buried in prose.
const ChatMessageActions: React.FC<ChatMessageActionsProps> = ({ actions }) => {
  const isConnected = useConnectedIntegrations();

  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {actions.map((action, i) => {
        const connected = isConnected[action.provider];
        return connected ? (
          <span key={i} className="btn btn-sm btn-disabled gap-1.5 opacity-60">
            <LuCircleCheck className="text-success" size={14} />
            {PROVIDER_LABEL[action.provider]} connected
          </span>
        ) : (
          <button
            key={i}
            className="btn btn-sm btn-primary gap-1.5"
            onClick={() => window.open(action.url, '_blank', 'noopener,noreferrer')}
          >
            {action.label}
            <LuExternalLink size={13} />
          </button>
        );
      })}
    </div>
  );
};

export default ChatMessageActions;
